export function updateGroupState({ state, dispatch }) {
	if (state.group && state.group.id) {
		dispatch('getGroup', { id: state.group.id })
		if (state.userGroups)
			dispatch('getUsers', { id: state.group.id })
	}
}
